import { useSubscriptionV2 } from '../../../../queries/use-firm-subscription';
import BillingSection from './BillingSection';
import QuotaUsageSection from './QuotaUsageSection';
import HistorySection from './HistorySection';
import PaymentSection from './PaymentSection';
import PlanSection from './PlanSection';
import TrialAlert from './TrialAlert';
import PausedAlert from './PausedAlert';
import CancelSection from './CancelSection';
import CancelAlert from './CancelAlert';

function BillingV2(): JSX.Element {
    const query = useSubscriptionV2();

    if (query.isLoading) {
        return <></>;
    }

    if (!query.isSuccess) {
        return <></>;
    }

    const subscription = query.data.subscription;

    return (
        <div>
            <TrialAlert subscription={subscription} />
            <PausedAlert subscription={subscription} />
            <CancelAlert subscription={subscription} />
            <div className="flex flex-col gap-8">
                <PlanSection subscription={subscription} />
                <hr />
                <QuotaUsageSection subscription={subscription} />
                <hr />
                <BillingSection />
                <hr />
                <PaymentSection subscription={subscription} />
                <hr />
                <HistorySection />
                <hr />
                <CancelSection subscription={subscription} />
            </div>
        </div>
    );
}

export default BillingV2;
